export default __webpack_public_path__ + "static/media/flag_spain.2df33d25.webp";